import React from 'react';
import PlanEditPage from './pages/PlanEditPage';
import PlansExplorerPage from './pages/PlansExplorerPage';
import PlanDetailsPage from './pages/PlanDetailsPage';
import AreaEditPage from './pages/AreaEditPage';
import AreaIndicatorEditPage from './pages/AreaIndicatorEditPage';
import B2BRoutesModule from '../b2b-common/B2BRoutesModule';

const plansRoutes = [
    { path: '/plans-explorer', element: <PlansExplorerPage />, visibility: 'private' },
    { path: '/plans-explorer/new', element: <PlanEditPage />, visibility: 'private' },
    { path: '/plans-explorer/edit', element: <PlanEditPage />, visibility: 'private' },
    { path: '/plans-explorer/:planUUID', element: <PlanDetailsPage />, visibility: 'private' },
    { path: '/plans-explorer/:planUUID/areaNew', element: <AreaEditPage />, visibility: 'private' },
    { path: '/plans-explorer/:planUUID/areaEdit', element: <AreaEditPage />, visibility: 'private' },
    { path: '/plans-explorer/:planUUID/:areaId/areaIndicatorNew', element: <AreaIndicatorEditPage />, visibility: 'private' },
    { path: '/plans-explorer/:planUUID/:areaId/areaIndicatorEdit', element: <AreaIndicatorEditPage />, visibility: 'private' },
    { path: '*', element: <h1>Not Found</h1> }
];

const B2BPlans = () => {
    return <B2BRoutesModule routes={plansRoutes} />;
}

export default B2BPlans;